"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTelephone = void 0;
const formatTelephone = telephone => {
  if (!telephone) return '';
  const cleaned = telephone.replace(/\D/g, '');
  const usMatch = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
  if (usMatch) {
    return "+1 (".concat(usMatch[1], ") ").concat(usMatch[2], "-").concat(usMatch[3]);
  }
  if (telephone.startsWith('+')) {
    return telephone;
  }
  return telephone;
};
exports.formatTelephone = formatTelephone;
//# sourceMappingURL=format-telephone.js.map